import { cn } from '@/lib/utils';
import { categoryLabels } from '@/data/mockData';

const categories = ['todas', 'cafe', 'almoco', 'jantar', 'lanches', 'bebidas'];
const categoryNames: Record<string, string> = { todas: 'Todas', ...categoryLabels };

interface RecipeCategoryFiltersProps {
  selected: string;
  onSelect: (cat: string) => void;
}

const RecipeCategoryFilters = ({ selected, onSelect }: RecipeCategoryFiltersProps) => (
  <div className="flex gap-1.5 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-hide">
    {categories.map((cat) => (
      <button
        key={cat}
        onClick={() => onSelect(cat)}
        className={cn(
          "flex-shrink-0 px-2.5 py-1 rounded-lg text-[11px] transition-all whitespace-nowrap",
          selected === cat ? "gradient-primary text-primary-foreground font-medium" : "bg-card border border-border"
        )}
      >
        {categoryNames[cat]}
      </button>
    ))}
  </div>
);

export default RecipeCategoryFilters;
